export const PAGE_SIZE = 20;

export const TABLE_HEADING = {
  column: [
    'ID',
    'Short Code',
    'Customer Mobile Number',
    'Message Content',
    'Received At',
    'Dispatched SMS',
    'Error Message',
  ],
};

export const NOT_FOUND_MESSAGE = 'No inbound messages found';

export const DEFAULT_FETCH_ERROR_MESSAGE =
  'Oops, something went wrong. Please try again.';

export const INITIAL_STATE = {
  inboundMessages: [],
  currentPage: 0,
  totalPages: 0,
  loading: false,
  fetchError: '',
};
